module.exports = __webpack_public_path__ + "img/logo_denstv.ca1b0ffe.png";